import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
} from "reactstrap";

/**
 * Campaign Charge Edit Form Component
 */
const CampaignChargeEditForm = ({
    store_domain,
    campaign_variable_charge,
    campaign_fixed_charge,
    onInputChange,
    onSubmit,
}) => {
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-store_domain-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Store Domain
                </Label>
                <Col sm={4}>
                    <Input
                        value={store_domain}
                        type="text"
                        name="store_domain"
                        className="form-control"
                        id="horizontal-store_domain-Input"
                        onChange={onInputChange}
                        readOnly
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-campaign_variable_charge-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Variable Charge(%)
                </Label>
                <Col sm={4}>
                    <Input
                        value={campaign_variable_charge}
                        type="number"
                        name="campaign_variable_charge"
                        className="form-control"
                        id="horizontal-campaign_variable_charge-Input"
                        onChange={onInputChange}
                        required
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-campaign_fixed_charge-Input"
                    className="col-sm-2 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Fixed Charge($)
                </Label>
                <Col sm={4}>
                    <Input
                        value={campaign_fixed_charge}
                        type="number"
                        name="campaign_fixed_charge"
                        className="form-control"
                        id="horizontal-campaign_fixed_charge-Input"
                        onChange={onInputChange}
                        required
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4 justify-content-end">
                <Col sm={10}>
                    <div>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                        >
                            Update
                        </Button>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    );
};

CampaignChargeEditForm.propTypes = {
    store_domain: PropTypes.string.isRequired,
    campaign_variable_charge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    campaign_fixed_charge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onInputChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default CampaignChargeEditForm;

